import React, { useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion, AnimatePresence } from "framer-motion";

const MotionModal = ({
  open,
  onClose,
  title,
  children,
  showClose = true,
  className = "",
  minWidth = "300px",
}) => {

  // 🔥 Lock body scroll when modal is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          {/* Overlay */}
          <div
            className="fixed inset-0 z-[999] flex items-center justify-center bg-black/30"
            onClick={onClose}
          >
            {/* Modal */}
            <motion.div
              initial={{ scale: 0.8, opacity: 0, y: 40 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 40 }}
              transition={{
                duration: 0.35,
                ease: [0.16, 1, 0.3, 1],
              }}
              onClick={(e) => e.stopPropagation()}
              className={`
                bg-white rounded-2xl 
                shadow-xl p-6 relative w-full max-w-lg mx-4
                ${className}
              `}
              style={{ minWidth }}
            >
              {/* Close Button */}
              {showClose && (
                <IconButton
                  onClick={onClose}
                  sx={{ position: "absolute", top: 12, right: 12, color: "grey.600" }}
                >
                  <CloseIcon />
                </IconButton>
              )}

              {/* Title */}
              {title && (
                <h2 className="text-xl font-semibold text-gray-800 200 mb-4">
                  {title}
                </h2>
              )}

              {/* Body */}
              <Box>{children}</Box>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MotionModal;
